import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
// import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
// const admin = localStorage.getItem("admin_details");

// @mui icons
import Icon from "@mui/material/Icon";

import Media from "Main/Views/Media";
import Levels from "Main/Views/Levels";
import Courses from "Main/Views/Courses";
import TeamsList from "Main/Views/Teams";
import SubjectsList from "Main/Views/Subjects";
import BatchesList from "Main/Views/Batch";
import AchieversList from "Main/Views/Achievers";
import ResultsList from "Main/Views/Results";
import Announcements from "Main/Views/Announcements";
import Popup from "Main/Views/Popup";
import HomeScreen from "Main/Views/HomeScreen";
import FaqList from "Main/Views/Faq";
import Gallery from "Main/Views/Gallery";
import Blogs from "Main/Views/Blogs";

let users = localStorage.getItem("admin_details");
let user;

if (users) {
  user = JSON.parse(users);
}

let routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Media",
    key: "media",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/media",
    component: <Media />,
  },
  {
    type: "collapse",
    name: "Levels",
    key: "levels",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/levels",
    component: <Levels />,
  },
  {
    type: "collapse",
    name: "Courses",
    key: "courses",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/courses",
    component: <Courses />,
  },

  {
    type: "collapse",
    name: "Our Team",
    key: "teams",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/teams",
    component: <TeamsList />,
  },

  {
    type: "collapse",
    name: "Subjects",
    key: "subjects",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/subjects",
    component: <SubjectsList />,
  },

  {
    type: "collapse",
    name: "Batch",
    key: "batch",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/batch",
    component: <BatchesList />,
  },

  {
    type: "collapse",
    name: "Achievers",
    key: "achievers",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/achievers",
    component: <AchieversList />,
  },
  {
    type: "collapse",
    name: "Results",
    key: "results",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/results",
    component: <ResultsList />,
  },
   {
    type: "collapse",
    name: "Announcements",
    key: "announcements",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/announcements",
    component: <Announcements />,
  },
   {
    type: "collapse",
    name: "Popup",
    key: "popup",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/popups",
    component: <Popup />,
  },
  {
    type: "collapse",
    name: "Home Screen",
    key: "homeScreen",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/homeScreen",
    component: <HomeScreen />,
  },
    {
    type: "collapse",
    name: "Faqs",
    key: "faqs",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/faqs",
    component: <FaqList />,
  },
  {
    type: "collapse",
    name: "Gallery",
    key: "gallery",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/gallery",
    component: <Gallery />,
  },
  {
    type: "collapse",
    name: "Blogs",
    key: "blogs",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/blogs",
    component: <Blogs />,
  },
];

let newRoutes = [];
let role = "superadmin";

if (role == "superadmin") {
  newRoutes = routes;
}
routes = newRoutes;
export default routes;
